<template>
  <div class="service-detail-section py-5">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 mb-4 mb-lg-0">
          <h2 class="service-title mb-4 text-center text-lg-left">
            {{
              (serviceData &&
                serviceData.serviceDetail &&
                serviceData.serviceDetail.title) ||
              "Service Details"
            }}
          </h2>
          <div class="service-description text-center text-lg-left">
            <p
              v-for="(paragraph, index) in (serviceData &&
                serviceData.serviceDetail &&
                serviceData.serviceDetail.description) ||
              []"
              :key="index"
              class="mb-4"
            >
              {{ paragraph }}
            </p>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="service-image-wrapper">
            <img
              :src="
                require(`../assets/imgs/${serviceData.serviceDetail.image}`)
              "
              :alt="getImageAlt()"
              :title="getImageTitle()"
              class="service-image img-fluid rounded shadow-lg"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceDetailSection",
  props: {
    serviceData: {
      type: Object,
      default: () => ({}),
    },
    cityName: {
      type: String,
      default: "",
    },
  },
  computed: {
    serviceImage() {
      if (
        this.serviceData &&
        this.serviceData.serviceDetail &&
        this.serviceData.serviceDetail.image
      ) {
        try {
          const imagePath = this.serviceData.serviceDetail.image.replace(
            "@/",
            "../"
          );
          return require(imagePath);
        } catch (error) {
          console.log("Error loading dynamic service image:", error);
        }
      }

      // Fallback to default
      try {
        return require("../assets/imgs/about-us.jpg");
      } catch (error) {
        console.log("Error loading default service image:", error);
        return "";
      }
    },
  },
  methods: {
    getImageAlt() {
      const baseAlt =
        (this.serviceData &&
          this.serviceData.serviceDetail &&
          this.serviceData.serviceDetail.imageAlt) ||
        "Professional garage door service";

      return this.cityName ? `${baseAlt} in ${this.cityName}` : baseAlt;
    },
    getImageTitle() {
      const baseTitle =
        (this.serviceData &&
          this.serviceData.serviceDetail &&
          this.serviceData.serviceDetail.imageTitle) ||
        "Expert Garage Door Services - Professional Installation and Repair with Quality Materials and Certified Technicians";

      if (this.cityName) {
        // Truncate base title if needed to accommodate city name
        const citySuffix = ` in ${this.cityName}`;
        const maxBaseLength = 155 - citySuffix.length;
        const truncatedBase =
          baseTitle.length > maxBaseLength
            ? baseTitle.substring(0, maxBaseLength).trim() + "..."
            : baseTitle;
        return `${truncatedBase}${citySuffix}`;
      }

      // Ensure title is within 150-160 character range
      if (baseTitle.length > 160) {
        return baseTitle.substring(0, 157).trim() + "...";
      } else if (baseTitle.length < 150) {
        return baseTitle + " - Trusted Local Garage Door Experts";
      }

      return baseTitle;
    },
  },
};
</script>

<style lang="scss" scoped>
.service-detail-section {
  background-color: #f8f9fa;

  .service-title {
    font-weight: 700;
    font-size: 2.25rem;
    line-height: 1.2;

    @media (max-width: 768px) {
      font-size: 1.75rem;
    }
  }

  .service-description {
    color: #6c757d;
    font-size: 1.1rem;
    line-height: 1.7;

    p {
      margin-bottom: 1rem;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .service-image-wrapper {
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: -15px;
      left: -15px;
      width: 100%;
      height: 100%;
      background: linear-gradient(135deg, #0d47a1, #0a1f5b);
      border-radius: 0.5rem;
      z-index: -1;
      opacity: 0.1;
    }
  }

  .service-image {
    width: 100%;
    height: auto;
    border-radius: 0.5rem;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    transition: transform 0.3s ease;

    &:hover {
      transform: translateY(-5px);
    }
  }

  @media (max-width: 991px) {
    .service-image-wrapper::before {
      display: none;
    }
  }
}
</style>
